import { useQuery } from '@tanstack/react-query';
import { getWingmanMetrics } from '../services/wingman';
import { wingmanQueryKeys } from './query-keys';
import { formatDateForApi } from '../utils/dateUtils';

export const useWingmanMetricsQuery = (startDate, endDate) => {
  const formattedStartDate = startDate ? formatDateForApi(startDate) : '';
  const formattedEndDate = endDate ? formatDateForApi(endDate) : '';
  const isDateRangeReady = Boolean(formattedStartDate && formattedEndDate);

  return useQuery({
    queryKey: wingmanQueryKeys.metrics(formattedStartDate, formattedEndDate),
    enabled: isDateRangeReady,
    queryFn: async () => {
      const result = await getWingmanMetrics({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });

      if (!result.success) {
        throw new Error(result.message || 'Failed to load wingman metrics');
      }

      return result.data;
    },
  });
};
